import { Box, Typography } from '@mui/material'

type FtuxStepHeaderProps = Readonly<{
  /** Step heading (matches Figma tooltip title row, left). */
  title: string
  /** 1-based step index for “n of total” (right). */
  stepIndex: number
  total: number
}>

/**
 * Tooltip header row — Figma Dev Handoff Tour 1 (`4154:4367`): title + “n of total”.
 */
export function FtuxStepHeader({ title, stepIndex, total }: FtuxStepHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        width: '100%',
        minHeight: 28,
      }}
    >
      <Typography
        component="span"
        sx={{
          fontWeight: 700,
          fontSize: 18,
          lineHeight: '28px',
          letterSpacing: '-0.4395px',
          color: '#04183f',
          flex: 1,
          minWidth: 0,
        }}
      >
        {title}
      </Typography>
      <Typography
        component="span"
        sx={{
          fontWeight: 400,
          fontSize: 14,
          lineHeight: '20px',
          letterSpacing: '-0.1504px',
          color: '#a2b1ba',
          flexShrink: 0,
        }}
      >
        {stepIndex} of {total}
      </Typography>
    </Box>
  )
}
